import { jobLogger } from './jobLogger-sidecar'
import { IJob, ITask } from './jobs'
import { jobs } from './jobs-sidecar'

export function createTask_custom(
  i: number,
  j: number,
  action: (task: ITask) => void,
): ITask {
  return jobs._createTask(i, j, 'custom', {
    action,
  })
}

export function runTask_custom(job: IJob, task: ITask) {
  jobLogger.assertTaskType(task, 'custom')
  task.action(task)
}
